import React from 'react';
import { Check } from '../common/IconsComponent';

const FormHeader = ({ title, buttonText, disabled, onClick, type = 'submit' }) => (
  <div className="flex items-center justify-between mb-4 sm:mb-6 pb-4 border-b border-gray-400">
    <h2 className="text-lg sm:text-xl font-bold text-gray-800">
      {title || 'מידע אישי'}
    </h2>
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`flex items-center gap-1.5 text-sm font-medium rounded-lg px-3 sm:px-4 py-2 transition-all duration-300 ${
        disabled
          ? 'bg-gray-300 text-gray-500 opacity-50 cursor-not-allowed'
          : 'bg-gradient-to-br from-blue-400 to-blue-800 text-white hover:bg-blue-700 hover:shadow-md'
      }`}
    >
      <Check size={15} />
      <span className="hidden sm:inline">{buttonText || 'שמירת שינויים'}</span>
      <span className="sm:hidden">שמור</span>
    </button>
  </div>
);

export default FormHeader;